import { Edit, Delete, Warning } from "@mui/icons-material";
import React from "react";
import { Tooltip, IconButton, Typography, Grid } from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import { setGarmentIds, setDefaultData } from "store/modules/StackGarment";

export const columns = (
  setOpen,
  setMode,
  setOpenDelete,
  dispatch
) => {
  return [
    {
      field: `${uuidv4()}`,
      headerName: "Acciones",
      width: 150,
      renderCell: (data) => (
        <React.Fragment>
          <Tooltip title="Editar" placement="top">
            <IconButton
              aria-label="edit"
              color="primary"
              onClick={() => {
                setOpen(true);
                setMode("PUT");
                dispatch(setDefaultData(data.row));
                dispatch(setGarmentIds(data.row.id));
              }}
            >
              <Edit />
            </IconButton>
          </Tooltip>
          <Tooltip title="Eliminar" placement="top">
            <IconButton
              aria-label="delete"
              color="primary"
              onClick={() => {
                setOpenDelete(true);
                setMode("DELETE");
                dispatch(setDefaultData(data.row));
              }}
            >
              <Delete />
            </IconButton>
          </Tooltip>
          {/* <Tooltip title="Imprimir" placement="top">
            <IconButton
              aria-label="print"
              color="primary"
                onClick={() => {
                  setDataDefault(data.row);
                  handleOpenPDF();
                }}
            >
              <PrintSharp />
            </IconButton>
          </Tooltip> */}
        </React.Fragment>
      ),
    },
    {
      field: "imagen",
      headerName: "Imagen",
      width: 100,
      renderCell: (data) => (
        <React.Fragment>
          <div
            style={{
              height: 50,
              width: 50,
              textAlign: "center",
              cursor: "pointer",
            }}
          >
            <img
              //   onClick={() => setOpen(true)}
              src={data.row.imagen}
              alt="Sin imagen"
            />
          </div>
        </React.Fragment>
      ),
    },
    {
      field: "modelo",
      headerName: "Modelo",
      width: 150,
    },
    {
      field: "nombre",
      hideable: true,
      headerName: "Producto",
      width: 300,
      renderCell: (data) => data.nombre,
    },
    {
      field: "sku",
      headerName: "SKU",
      width: 200,
    },
    {
      field: "total",
      headerName: "Total de Prendas",
      width: 200,
    },
  ];
};
